module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[66]553.896aee6.woff2";